import React from 'react';
import { Bonuses, FAQ, Guarantee, PainAndTransformation, ProductOverview, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2risy0r0e74jk">
      <MetaPixel data-id="element-1" data-mp="31agput0v2nlk" />
      <TopBar data-id="element-2" data-mp="31ayv2f5i4c5m" />
      <main data-id="element-3" data-mp="31bi9vmzuukff">
        <Hero data-id="element-4" data-mp="31c1hoavsjsfq" />
        <Testimonials data-id="element-5" data-mp="31ctetq51dy84" />
        <PainAndTransformation data-id="element-6" data-mp="2wka20ve6b74d" />
        <ProductOverview data-id="element-7" data-mp="2wiyvintcfl9k" />
        <Bonuses data-id="element-8" data-mp="2wip7v6vrtq71" />
        <Pricing data-id="element-9" data-mp="2wi5lndz38fn7" />
        <FAQ data-id="element-10" data-mp="28u5zkrcq1dey" />
        <Guarantee data-id="element-11" data-mp="28tmex2vosax8" />
      </main>
      <Footer data-id="element-12" data-mp="28suw6sn6u7od" />
      <FloatingElements data-id="element-13" data-mp="28sbb5328r364" />
      <noscript data-id="element-14" data-mp="23vcm2yxfpmes">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-15" data-mp="23vupcfiil0w7" />
      </noscript>
    </div>;
}